<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Workflow Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading :title="`Edit ${test_process.name} Process`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['add test process']">
      <template #gated-content>
        <WorkflowTestProcessForm
          :sample_type="sample_type"
          :test_process="test_process"
          @submit="submit"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import { getModel } from '@/shared/fetch-utils'
import WorkflowTestProcessForm from '@/components/lab/workflows/test/WorkflowTestProcessForm'
import { LabRepositoryFactory } from '@/repositories/lab/LabRepositoryFactory'
import { notificationOptions } from '@/shared/toast-notification-options'
import { testProcessNotifications } from '@/shared/notifications'
import { TestWorkflowRoutes } from '@/router/lab/TestWorkflowRoutes'

const TestProcessRepository = LabRepositoryFactory.get('testProcess')

Vue.use(VueNotifications, notificationOptions)

export default {
  name: 'WorkflowTestProcessEdit',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    WorkflowTestProcessForm
  },
  data () {
    return {
      loading: true,
      sample_type_id: this.$route.params.sample_type_id || null,
      sample_type: null,

      test_process_id: this.$route.params.test_process_id || null,
      test_process: null
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
        ]
      }
    },
    route_root () {
      return TestWorkflowRoutes.fetchRoot()
    }
  },
  async mounted () {
    this.loading = true

    this.sample_type = await getModel({
      model_type: 'sample_type',
      id: this.sample_type_id,
      message: this.$bvToast
    })

    this.test_process = await getModel({
      model_type: 'test_process',
      id: this.test_process_id,
      message: this.$bvToast
    })

    this.test_process && this.sample_type ? (this.loading = false) : this.$router.back()
  },
  methods: {
    async submit (form_data) {
      try {
        const { data } = await TestProcessRepository.update(this.test_process_id, form_data)

        this.addSuccess()
        this.$router.push(`/${this.route_root}/${this.sample_type_id}/${data.id}`)
      } catch ({ response }) {
        const { status, data } = response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    }
  },
  notifications: testProcessNotifications
}
</script>
